<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
  <p>Are you sure to ungroup {{occurances}} faults?</p>
</div>
<div mat-dialog-actions>
  <button mat-button color="warn" (click)="onClick(true)">Yes</button>
  <button mat-button (click)="onClick(false)">No</button>
</div>